import { MARQUEE_WORDS } from "@/data/content";

export default function Marquee({ className = "" }) {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div className={`overflow-hidden py-10 select-none ${className}`} aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="font-serif italic text-3xl md:text-4xl text-charcoal/25">{w}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-gold/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
